import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import * as BsIcons from 'react-icons/bs';
import {
  BsBarChartLineFill,
  BsStarFill,
  BsPeopleFill,
  BsPlayCircleFill,
  BsFileEarmarkTextFill,
} from 'react-icons/bs'; // Bootstrap Icons via react-icons

// const stats = [
//   {
//     icon: <BsBarChartLineFill size={28} color="#F5A623" />,
//     title: 'Beginner Level',
//     subtitle: 'Recommended Experience',
//   },
//   {
//     icon: <BsStarFill size={28} color="#F5A623" />,
//     title: '4.3',
//     subtitle: '15,432 ratings',
//   },
//   {
//     icon: <BsPeopleFill size={28} color="#F5A623" />,
//     title: '1,24,446',
//     subtitle: 'Our Learners',
//   },
//   {
//     icon: <BsPlayCircleFill size={28} color="#F5A623" />,
//     title: '30',
//     subtitle: 'Video Lectures',
//   },
//   {
//     icon: <BsFileEarmarkTextFill size={28} color="#F5A623" />,
//     title: '100+',
//     subtitle: 'Test Papers',
//   },
// ];

const StatsBanner = (props) => {
  const { data } = props;
  const [stats, setStats] = useState([]);

  useEffect(() => {
    if (data) {
      setStats(data);
    }
  }, [data]);
  return (
    <div className="stat_banner bg-white py-4 px-2 rounded-4 mx-auto" style={{ maxWidth: '1000px' }}>
      <Container>
        <Row className="text-center justify-content-around align-items-center position-relative">
          {stats.map((stat, idx) => {
            const IconComponent = BsIcons[stat.icon]; 
            return (
              <Col key={idx} md className="d-flex flex-column align-items-center px-3 position-relative">
                {IconComponent && <IconComponent size={28} color="#F5A623" />}
                <h5 className="fw-bold mt-2 mb-0">{stat.key}</h5>
                <small className="text-muted">{stat.value}</small>
                {/* Vertical divider between columns (except last one) */}
                {idx < stats.length - 1 && (
                  <div
                    className="d-none d-md-block"
                    style={{
                      position: 'absolute',
                      right: 0,
                      top: '25%',
                      height: '50%',
                      width: '1px',
                      backgroundColor: '#ccc',
                    }}
                  />
                )}
              </Col>
            );
          })}
        </Row>
      </Container>
    </div>
  );
};

export default StatsBanner;
